"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MDBootboxImplementation = void 0;
var MDBootboxImplementation = (function () {
    function MDBootboxImplementation() {
    }
    MDBootboxImplementation.prototype.alert = function (message, callback) {
        var options = MDBootboxImplementation.mergeDialogOptions("alert", ["ok"], ["message", "callback"], arguments);
        if (options.callback && !$.isFunction(options.callback)) {
            throw new Error("alert requires callback property to be a function when provided");
        }
        options.buttons.ok.callback = options.onEscape = function () {
            if ($.isFunction(options.callback)) {
                return options.callback.call(this, true);
            }
            return true;
        };
        return this.dialog(options);
    };
    MDBootboxImplementation.prototype.confirm = function (message, callback) {
        var options = MDBootboxImplementation.mergeDialogOptions("confirm", ["confirm", "cancel"], ["message", "callback"], arguments);
        if (!$.isFunction(options.callback)) {
            throw new Error("confirm requires a callback");
        }
        options.buttons.cancel.callback = options.onEscape = function () {
            return options.callback.call(this, false);
        };
        options.buttons.confirm.callback = function () {
            return options.callback.call(this, true);
        };
        return this.dialog(options);
    };
    MDBootboxImplementation.prototype.prompt = function (message, callback) {
        var options;
        var defaults;
        var dialog;
        var form;
        var input;
        var shouldShow;
        var inputOptions;
        form = $(MDBootboxImplementation.templates.form);
        defaults = {
            className: "bootbox-prompt",
            buttons: MDBootboxImplementation.createLabels("confirm", "cancel"),
            value: "",
            inputType: "text"
        };
        options = MDBootboxImplementation.validateButtons(MDBootboxImplementation.mergeArguments(defaults, arguments, ["title", "callback"]), ["confirm", "cancel"]);
        shouldShow = (options.show === undefined) ? true : options.show;
        options.message = form;
        options.buttons.cancel.callback = options.onEscape = function () {
            return options.callback.call(this, null);
        };
        options.buttons.confirm.callback = function () {
            var value;
            if (options.inputType === "checkbox") {
                value = input.find("input:checked").map(function () {
                    return $(this).val();
                }).get();
            }
            else {
                value = input.val();
            }
            return options.callback.call(this, value);
        };
        options.show = false;
        if (!options.title) {
            throw new Error("prompt requires a title");
        }
        if (!$.isFunction(options.callback)) {
            throw new Error("prompt requires a callback");
        }
        if (!MDBootboxImplementation.templates.inputs[options.inputType]) {
            throw new Error("invalid prompt type");
        }
        input = $(MDBootboxImplementation.templates.inputs[options.inputType]);
        switch (options.inputType) {
            case "text":
            case "textarea":
            case "email":
            case "date":
            case "time":
            case "number":
            case "password":
                input.val(options.value);
                break;
            case "select":
                var groups = {};
                inputOptions = options.inputOptions || [];
                if (!$.isArray(inputOptions)) {
                    throw new Error("Please pass an array of input options");
                }
                if (!inputOptions.length) {
                    throw new Error("prompt with select requires options");
                }
                MDBootboxImplementation.each(inputOptions, function (_, option) {
                    var elem = input;
                    if (option.value === undefined || option.text === undefined) {
                        throw new Error("each option needs a `value` and a `text` property");
                    }
                    if (option.group) {
                        if (!groups[option.group]) {
                            groups[option.group] = $("<optgroup/>").attr("label", option.group);
                        }
                        elem = groups[option.group];
                    }
                    elem.append("<option value='" + option.value + "'>" + option.text + "</option>");
                });
                MDBootboxImplementation.each(groups, function (_, group) {
                    input.append(group);
                });
                input.val(options.value);
                break;
            case "checkbox":
                var values = $.isArray(options.value) ? options.value : [options.value];
                inputOptions = options.inputOptions || [];
                if (!inputOptions.length) {
                    throw new Error("prompt with checkbox requires options");
                }
                if (!inputOptions[0].value || !inputOptions[0].text) {
                    throw new Error("each option needs a `value` and a `text` property");
                }
                input = $("<div/>");
                MDBootboxImplementation.each(inputOptions, function (_, option) {
                    var checkbox = $(MDBootboxImplementation.templates.inputs[options.inputType]);
                    checkbox.find("input").attr("value", option.value);
                    checkbox.find("label").append(option.text);
                    MDBootboxImplementation.each(values, function (_, value) {
                        if (value === option.value) {
                            checkbox.find("input").prop("checked", true);
                        }
                    });
                    input.append(checkbox);
                });
                break;
        }
        if (options.placeholder) {
            input.attr("placeholder", options.placeholder);
        }
        if (options.pattern) {
            input.attr("pattern", options.pattern);
        }
        if (options.maxlength) {
            input.attr("maxlength", options.maxlength);
        }
        form.append(input);
        form.on("submit", function (e) {
            e.preventDefault();
            e.stopPropagation();
            dialog.find(".btn-primary").trigger("click");
        });
        dialog = this.dialog(options);
        dialog.off("shown.bs.modal");
        dialog.on("shown.bs.modal", function () {
            input.trigger("focus");
        });
        if (shouldShow === true) {
            dialog.modal("show");
        }
        return dialog;
    };
    MDBootboxImplementation.prototype.dialog = function (message, callback) {
        var options;
        if (typeof message === "string") {
            options = {
                message: message,
                callback: callback
            };
        }
        else {
            options = message;
        }
        options = MDBootboxImplementation.sanitize(options);
        var dialog = $(MDBootboxImplementation.templates.dialog);
        var innerDialog = dialog.find(".modal-dialog");
        var body = dialog.find(".modal-body");
        var buttons = options.buttons;
        var buttonStr = "";
        var callbacks = {
            onEscape: options.onEscape
        };
        if ($.fn.modal === undefined) {
            throw new Error("$.fn.modal is not defined; please double check you have included " +
                "the Bootstrap JavaScript library. See http://getbootstrap.com/javascript/ " +
                "for more details.");
        }
        MDBootboxImplementation.each(buttons, function (key, button) {
            buttonStr += "<button data-bb-handler='" + key + "' type='button' class='btn " + button.className + "'>" + button.label + "</button>";
            callbacks[key] = button.callback;
        });
        body.find(".bootbox-body").html(options.message);
        if (options.animate === true) {
            dialog.addClass("fade");
        }
        if (options.className) {
            dialog.addClass(options.className);
        }
        if (options.size === "large") {
            innerDialog.addClass("modal-lg");
        }
        else if (options.size === "small") {
            innerDialog.addClass("modal-sm");
        }
        if (options.title) {
            body.before(MDBootboxImplementation.templates.header);
        }
        if (options.closeButton) {
            var closeButton = $(MDBootboxImplementation.templates.closeButton);
            if (options.title) {
                dialog.find(".modal-header").append(closeButton);
            }
            else {
                closeButton.css("margin-top", "-2px").prependTo(body);
            }
        }
        if (options.title) {
            dialog.find(".modal-title").html(options.title);
        }
        if (buttonStr.length) {
            body.after(MDBootboxImplementation.templates.footer);
            dialog.find(".modal-footer").html(buttonStr);
        }
        dialog.one("hide.bs.modal", function () {
            dialog.off("escape.close.bb");
            dialog.off("click");
        });
        dialog.one("hidden.bs.modal", function (e) {
            if (e.target === this) {
                dialog.remove();
            }
        });
        dialog.one("shown.bs.modal", function () {
            dialog.find(".btn-primary:first").trigger("focus");
        });
        if (options.backdrop !== "static") {
            dialog.on("click.dismiss.bs.modal", function (e) {
                if (dialog.children(".modal-backdrop").length) {
                    e.currentTarget = dialog.children(".modal-backdrop").get(0);
                }
                if (e.target !== e.currentTarget) {
                    return;
                }
                dialog.trigger("escape.close.bb");
            });
        }
        dialog.on("escape.close.bb", function (e) {
            if (callbacks.onEscape) {
                MDBootboxImplementation.processCallback(e, dialog, callbacks.onEscape);
            }
        });
        dialog.on("click", ".modal-footer button", function (e) {
            var callbackKey = $(this).data("bb-handler");
            MDBootboxImplementation.processCallback(e, dialog, callbacks[callbackKey]);
        });
        dialog.on("click", ".bootbox-close-button", function (e) {
            MDBootboxImplementation.processCallback(e, dialog, callbacks.onEscape);
        });
        dialog.on("keyup", function (e) {
            if (e.which === 27) {
                dialog.trigger("escape.close.bb");
            }
        });
        $(options.container).append(dialog);
        dialog.modal({
            backdrop: options.backdrop ? "static" : false,
            keyboard: false,
            show: false
        });
        if (options.show) {
            dialog.modal("show");
        }
        return dialog;
    };
    MDBootboxImplementation.prototype.setDefaults = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var values = {};
        if (arguments.length === 2) {
            values[arguments[0]] = arguments[1];
        }
        else {
            values = arguments[0];
        }
        $.extend(MDBootboxImplementation.defaults, values);
    };
    MDBootboxImplementation.prototype.hideAll = function () {
        $(".bootbox").modal("hide");
    };
    MDBootboxImplementation.prototype.addLocale = function (name, values) {
        $.each(["OK", "CANCEL", "CONFIRM"], function (_, v) {
            if (!values[v]) {
                throw new Error("Please supply a translation for '" + v + "'");
            }
        });
        MDBootboxImplementation.locales[name] = {
            OK: values.OK,
            CANCEL: values.CANCEL,
            CONFIRM: values.CONFIRM
        };
    };
    MDBootboxImplementation.prototype.removeLocale = function (name) {
        delete MDBootboxImplementation.locales[name];
    };
    MDBootboxImplementation.prototype.setLocale = function (name) {
        return this.setDefaults("locale", name);
    };
    MDBootboxImplementation.translate = function (key) {
        var locale = MDBootboxImplementation.locales[MDBootboxImplementation.defaults.locale];
        return locale ? locale[key] : MDBootboxImplementation.locales.en[key];
    };
    MDBootboxImplementation.processCallback = function (e, dialog, callback) {
        e.stopPropagation();
        e.preventDefault();
        var preserveDialog = $.isFunction(callback) && callback.call(dialog, e) === false;
        if (!preserveDialog) {
            dialog.modal("hide");
        }
    };
    MDBootboxImplementation.getKeyLength = function (obj) {
        if (Object.keys) {
            return Object.keys(obj).length;
        }
        var k, t = 0;
        for (k in obj) {
            t++;
        }
        return t;
    };
    MDBootboxImplementation.each = function (collection, iterator) {
        var index = 0;
        $.each(collection, function (key, value) {
            iterator(key, value, index++);
        });
    };
    MDBootboxImplementation.sanitize = function (options) {
        var buttons;
        var total;
        if (typeof options !== "object") {
            throw new Error("Please supply an object of options");
        }
        if (!options.message) {
            throw new Error("Please specify a message");
        }
        options = $.extend({}, MDBootboxImplementation.defaults, options);
        if (!options.buttons) {
            options.buttons = {};
        }
        buttons = options.buttons;
        total = MDBootboxImplementation.getKeyLength(buttons);
        MDBootboxImplementation.each(buttons, function (key, button, index) {
            var isLast = index === total - 1;
            if ($.isFunction(button)) {
                button = buttons[key] = {
                    callback: button
                };
            }
            if ($.type(button) !== "object") {
                throw new Error("button with key " + key + " must be an object");
            }
            if (!button.label) {
                button.label = key;
            }
            if (!button.className) {
                if (total <= 2 && isLast) {
                    button.className = "btn-secondary";
                }
                else {
                    button.className = "btn-primary";
                }
            }
        });
        return options;
    };
    MDBootboxImplementation.mapArguments = function (args, properties) {
        var argn = args.length;
        var options = {};
        if (argn < 1 || argn > 2) {
            throw new Error("Invalid argument length");
        }
        if (argn === 2 || typeof args[0] === "string") {
            options[properties[0]] = args[0];
            options[properties[1]] = args[1];
        }
        else {
            options = args[0];
        }
        return options;
    };
    MDBootboxImplementation.mergeArguments = function (defaults, args, properties) {
        return $.extend(true, {}, defaults, MDBootboxImplementation.mapArguments(args, properties));
    };
    MDBootboxImplementation.mergeDialogOptions = function (className, labels, properties, args) {
        var baseOptions = {
            className: "bootbox-" + className,
            buttons: MDBootboxImplementation.createLabels.apply(null, labels)
        };
        return MDBootboxImplementation.validateButtons(MDBootboxImplementation.mergeArguments(baseOptions, args, properties), labels);
    };
    MDBootboxImplementation.createLabels = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var buttons = {};
        for (var i = 0, j = arguments.length; i < j; i++) {
            var argument = arguments[i];
            var key = argument.toLowerCase();
            var value = argument.toUpperCase();
            buttons[key] = {
                label: MDBootboxImplementation.translate(value)
            };
        }
        return buttons;
    };
    MDBootboxImplementation.validateButtons = function (options, buttons) {
        var allowedButtons = {};
        MDBootboxImplementation.each(buttons, function (key, value) {
            allowedButtons[value] = true;
        });
        MDBootboxImplementation.each(options.buttons, function (key) {
            if (allowedButtons[key] === undefined) {
                throw new Error("button key " + key + " is not allowed (options are " + buttons.join("\n") + ")");
            }
        });
        return options;
    };
    MDBootboxImplementation.Instance = new MDBootboxImplementation();
    MDBootboxImplementation.templates = {
        dialog: "<div class='bootbox modal' tabindex='-1' role='dialog' aria-hidden='true'>" +
            "<div class='modal-dialog'>" +
            "<div class='modal-content'>" +
            "<div class='modal-body'><div class='bootbox-body'></div></div>" +
            "</div>" +
            "</div>" +
            "</div>",
        header: "<div class='modal-header'>" +
            "<h4 class='modal-title'></h4>" +
            "</div>",
        footer: "<div class='modal-footer'></div>",
        closeButton: "<button type='button' class='bootbox-close-button close' aria-hidden='true'>&times;</button>",
        form: "<form class='bootbox-form'></form>",
        inputs: {
            text: "<input class='bootbox-input bootbox-input-text form-control' autocomplete=off type=text />",
            textarea: "<textarea class='bootbox-input bootbox-input-textarea form-control'></textarea>",
            email: "<input class='bootbox-input bootbox-input-email form-control' autocomplete='off' type='email' />",
            select: "<select class='bootbox-input bootbox-input-select form-control'></select>",
            checkbox: "<div class='checkbox'><label><input class='bootbox-input bootbox-input-checkbox' type='checkbox' /></label></div>",
            date: "<input class='bootbox-input bootbox-input-date form-control' autocomplete=off type='date' />",
            time: "<input class='bootbox-input bootbox-input-time form-control' autocomplete=off type='time' />",
            number: "<input class='bootbox-input bootbox-input-number form-control' autocomplete=off type='number' />",
            password: "<input class='bootbox-input bootbox-input-password form-control' autocomplete='off' type='password' />"
        }
    };
    MDBootboxImplementation.defaults = {
        locale: "en",
        backdrop: "static",
        animate: true,
        className: null,
        closeButton: true,
        show: true,
        container: "body"
    };
    MDBootboxImplementation.locales = {
        ar: {
            OK: "موافق",
            CANCEL: "الغاء",
            CONFIRM: "تأكيد"
        },
        az: {
            OK: "OK",
            CANCEL: "İmtina et",
            CONFIRM: "Təsdiq et"
        },
        bg_BG: {
            OK: "Ок",
            CANCEL: "Отказ",
            CONFIRM: "Потвърждавам"
        },
        br: {
            OK: "OK",
            CANCEL: "Cancelar",
            CONFIRM: "Sim"
        },
        cs: {
            OK: "OK",
            CANCEL: "Zrušit",
            CONFIRM: "Potvrdit"
        },
        da: {
            OK: "OK",
            CANCEL: "Annuller",
            CONFIRM: "Accepter"
        },
        de: {
            OK: "OK",
            CANCEL: "Abbrechen",
            CONFIRM: "Akzeptieren"
        },
        el: {
            OK: "Εντάξει",
            CANCEL: "Ακύρωση",
            CONFIRM: "Επιβεβαίωση"
        },
        en: {
            OK: "OK",
            CANCEL: "Cancel",
            CONFIRM: "OK"
        },
        es: {
            OK: "OK",
            CANCEL: "Cancelar",
            CONFIRM: "Aceptar"
        },
        eu: {
            OK: "OK",
            CANCEL: "Ezeztatu",
            CONFIRM: "Onartu"
        },
        et: {
            OK: "OK",
            CANCEL: "Katkesta",
            CONFIRM: "OK"
        },
        fa: {
            OK: "قبول",
            CANCEL: "لغو",
            CONFIRM: "تایید"
        },
        fi: {
            OK: "OK",
            CANCEL: "Peruuta",
            CONFIRM: "OK"
        },
        fr: {
            OK: "OK",
            CANCEL: "Annuler",
            CONFIRM: "Confirmer"
        },
        he: {
            OK: "אישור",
            CANCEL: "ביטול",
            CONFIRM: "אישור"
        },
        hu: {
            OK: "OK",
            CANCEL: "Mégsem",
            CONFIRM: "Megerősít"
        },
        hr: {
            OK: "OK",
            CANCEL: "Odustani",
            CONFIRM: "Potvrdi"
        },
        id: {
            OK: "OK",
            CANCEL: "Batal",
            CONFIRM: "OK"
        },
        it: {
            OK: "OK",
            CANCEL: "Annulla",
            CONFIRM: "Conferma"
        },
        ja: {
            OK: "OK",
            CANCEL: "キャンセル",
            CONFIRM: "確認"
        },
        ko: {
            OK: "OK",
            CANCEL: "취소",
            CONFIRM: "확인"
        },
        lt: {
            OK: "Gerai",
            CANCEL: "Atšaukti",
            CONFIRM: "Patvirtinti"
        },
        lv: {
            OK: "Labi",
            CANCEL: "Atcelt",
            CONFIRM: "Apstiprināt"
        },
        nl: {
            OK: "OK",
            CANCEL: "Annuleren",
            CONFIRM: "Accepteren"
        },
        no: {
            OK: "OK",
            CANCEL: "Avbryt",
            CONFIRM: "OK"
        },
        pl: {
            OK: "OK",
            CANCEL: "Anuluj",
            CONFIRM: "Potwierdź"
        },
        pt: {
            OK: "OK",
            CANCEL: "Cancelar",
            CONFIRM: "Confirmar"
        },
        ru: {
            OK: "OK",
            CANCEL: "Отмена",
            CONFIRM: "Применить"
        },
        sk: {
            OK: "OK",
            CANCEL: "Zrušiť",
            CONFIRM: "Potvrdiť"
        },
        sl: {
            OK: "OK",
            CANCEL: "Prekliči",
            CONFIRM: "Potrdi"
        },
        sq: {
            OK: "OK",
            CANCEL: "Anulo",
            CONFIRM: "Prano"
        },
        sv: {
            OK: "OK",
            CANCEL: "Avbryt",
            CONFIRM: "OK"
        },
        th: {
            OK: "ตกลง",
            CANCEL: "ยกเลิก",
            CONFIRM: "ยืนยัน"
        },
        tr: {
            OK: "Tamam",
            CANCEL: "İptal",
            CONFIRM: "Onayla"
        },
        uk: {
            OK: "OK",
            CANCEL: "Відміна",
            CONFIRM: "Прийняти"
        },
        zh_CN: {
            OK: "OK",
            CANCEL: "取消",
            CONFIRM: "确认"
        },
        zh_TW: {
            OK: "OK",
            CANCEL: "取消",
            CONFIRM: "確認"
        }
    };
    return MDBootboxImplementation;
}());
exports.MDBootboxImplementation = MDBootboxImplementation;
